import { ICaseSend } from 'src/types/case';
import moment from 'moment';

import { CaseFormData } from 'src/screens/General/screens/Cases/components/CaseForm';

export const groupCase = (dataForm: Partial<CaseFormData>): Partial<ICaseSend> => {
    const {
        externalRatePerHour,
        externalRatePerHourDate,
        internalRatePerHourDate,
        serviceTypeDescription,
        serviceLocationDate,
        providerDropDownDate,
        externalEvalHourlyRateDate,
        allocatedHours,
        totalHoursWorked,
        credit,
        invoiceStartNumber,
        studentDropDown,
        openingBalance,
        //        numberOfHoursBilled,
        externalEvalHourlyRate,
        internalRatePerHour,
        orderTypeDropDown,
        ordersDropDown,
        caseTypeDropDown,
        minPerUnitDropdown,
        serviceTypeProviderDropDown,
        serviceTypeDropDown,
        vendorDropDown,
        invoiceSignerDropdown,
        caseStatusDropdown,
        providerDropDown,
        districtDropDown,
        serviceLocationDropDown,
        rateAdvanceValue,
        rateAdvanceDate,
        isDatasheetRequired,
        isBonused,
        serviceTypeCpt,
        ...data
    } = dataForm;

    delete data.rateAdvances;
    //Partial<ICaseSend>
    const dataSend: any = {
        ...data,
    };

    dataSend.isDatasheetRequired = !!isDatasheetRequired;
    dataSend.isBonused = !!isBonused;
    if (orderTypeDropDown) {
        dataSend.orderType = +orderTypeDropDown.value;
    }

    if (studentDropDown) {
        dataSend.student = +studentDropDown.value;
        delete dataSend.vendor;
        delete dataSend.district;
    }
    if (districtDropDown) {
        dataSend.district = +districtDropDown.value;
       // delete dataSend.student;
        delete dataSend.vendor;
    }
    if (vendorDropDown) {
        dataSend.vendor = +vendorDropDown.value;
        delete dataSend.student;
        delete dataSend.district;
    }

    if (minPerUnitDropdown) {
        dataSend.minPerUnit = +minPerUnitDropdown.value;
    }
    if (serviceTypeProviderDropDown) {
        dataSend.serviceTypeProvider = +serviceTypeProviderDropDown.value;
    }

    if (caseStatusDropdown) {
        dataSend.status = +caseStatusDropdown.value;
    }
    if (providerDropDown) {
        dataSend.provider = providerDropDown.value;
    }
    delete dataSend.occasionProviders;
    if (providerDropDown) {
        let createdAt = dataForm.caseNumberValidityFrom;

        if (providerDropDownDate) {
            createdAt = moment.parseZone(providerDropDownDate).format('YYYY-MM-DD');
        }
        dataSend.occasionProviders = [
            {
                provider: providerDropDown.value,
                status: 1,
                serviceTypeDescription: serviceTypeDescription,
                createdAt: createdAt,
            },
        ];
    }

    delete dataSend.occasionServiceLocations;
    if (serviceLocationDropDown) {
        let createdAt = dataForm.caseNumberValidityFrom;
        if (serviceLocationDate) {
            createdAt = moment.parseZone(serviceLocationDate).format('YYYY-MM-DD');
        }
        dataSend.occasionServiceLocations = [
            {
                serviceLocation: serviceLocationDropDown.value,
                status: 1,
                createdAt: createdAt,
            },
        ];
    }

    if (serviceTypeDropDown) {
        dataSend.serviceType = serviceTypeDropDown.value;
    }

    if (serviceTypeCpt && serviceTypeCpt.value !== undefined) {
        dataSend.serviceTypeCpt = serviceTypeCpt.value;
    }

    if (orderTypeDropDown) {
        dataSend.orderType = +orderTypeDropDown.value;
    }

    if (ordersDropDown) {
        dataSend.orderEntity = ordersDropDown.value;
    }
    if (caseTypeDropDown) {
        dataSend.caseType = +caseTypeDropDown.value;
    }
    delete dataSend.occasionExternalRates;
    if (externalRatePerHour) {
        let createdAt = dataForm.caseNumberValidityFrom;
        if (externalRatePerHourDate) {
            createdAt = moment.parseZone(externalRatePerHourDate).format('YYYY-MM-DD');
        }

        dataSend.occasionExternalRates = [
            {
                externalRatePerHour: externalRatePerHour,
                status: 1,
                createdAt: createdAt,
            },
        ];
    }
    delete dataSend.occasionInternalRates;
    if (internalRatePerHour) {
        let createdAt = dataForm.caseNumberValidityFrom;
        if (internalRatePerHourDate) {
            createdAt = moment.parseZone(internalRatePerHourDate).format('YYYY-MM-DD');
        }
        dataSend.occasionInternalRates = [
            {
                internalRatePerHour: internalRatePerHour,
                status: 1,
                createdAt: createdAt,
            },
        ];
    }

    /*
        rateAdvance,
        rateAdvanceDate,
   "rateAdvances": [
        {
            "rateForAdvance": "20.02",
            "status": 1,
            "createdAt": "2021-06-30T00:00:00+00:00"
        }
    ]*/
    const rateAdvancesArr = [];
    if (rateAdvanceValue || rateAdvanceDate) {
        let createdAt = dataForm.caseNumberValidityFrom;

        if (rateAdvanceDate) {
            createdAt = moment.parseZone(rateAdvanceDate).format('YYYY-MM-DD');
        }
        rateAdvancesArr.push({
            rateForAdvance: rateAdvanceValue,
            status: 1,
            createdAt: createdAt,
        });
        dataSend.rateAdvances = rateAdvancesArr;
    }
    if (openingBalance) {
        dataSend.openingBalance = parseFloat(`${openingBalance}`);
    }
    delete dataSend.occasionExternalEvalRates;
    if (externalEvalHourlyRate) {
        let createdAt = dataForm.caseNumberValidityFrom;
        if (externalEvalHourlyRateDate) {
            createdAt = moment.parseZone(externalEvalHourlyRateDate).format('YYYY-MM-DD');
        }
        dataSend.occasionExternalEvalRates = [
            {
                externalEvalHourlyRate: externalEvalHourlyRate,
                status: 1,
                createdAt: createdAt,
            },
        ];
    }
    /*    if (numberOfHoursBilled) {
        dataSend.numberOfHoursBilled = parseFloat(`${numberOfHoursBilled}`);
    }*/
    if (totalHoursWorked) {
        dataSend.totalHoursWorked = parseFloat(`${totalHoursWorked}`);
    }
    if (allocatedHours) {
        dataSend.allocatedHours = +parseFloat(`${allocatedHours}`);
    }
    if (invoiceStartNumber) {
        dataSend.invoiceStartNumber = parseFloat(`${invoiceStartNumber}`);
    }

    if (credit) {
        dataSend.credit = parseFloat(`${credit}`);
    }

    if (invoiceSignerDropdown) {
        dataSend.invoiceSigner = +invoiceSignerDropdown.value;
    }

    dataSend.step = 1;
    delete dataSend.created;
    delete dataSend.createdAt;
    delete dataSend.updated;
    delete dataSend.updatedAt;

    return dataSend;
};
